// extracted by mini-css-extract-plugin
module.exports = {"checkBoxWrapper":"CardCheckBox_checkBoxWrapper__2gFjC","checkBox":"CardCheckBox_checkBox__3iizn"};